/**
 * notify · 通知中心类型（L0 data 层 · 经 repository.notifyRepo 对外提供）
 * ------------------------------------------------------------
 * 类别：todo 待办与任务指派 / approval 审批进展 / announce 公告周知。
 * 面板整体列表不分页签，类别仅用于通知偏好过滤。
 * 数据由服务端 platform.notification 持久化（含已读态 read），无本地 fixture。
 */

export type NotifTab = 'todo' | 'approval' | 'announce'
export interface NotifItem { id: string; tab: NotifTab; title: string; sub: string; time: string; to?: string; read?: boolean }

/* 通知方式选项（设置中心「通知偏好」按此渲染）：重要程度级别 × 下发渠道。
   新增级别或渠道时只需改本文件，设置页 UI 零改动；key 稳定入 localStorage（ema.notify.matrix.v1）。 */
export interface NotifyOption { key: string; name: string }
export const NOTIFY_LEVELS: NotifyOption[] = [
  { key: 'urgent', name: '紧急' },
  { key: 'important', name: '重要' },
  { key: 'normal', name: '一般' }
]
export const NOTIFY_CHANNELS: NotifyOption[] = [
  { key: 'inapp', name: '系统消息' },
  { key: 'push', name: '浏览器推送' },
  { key: 'app', name: 'App 推送' },
  { key: 'sms', name: '短信' },
  { key: 'email', name: '邮箱' },
  { key: 'wechat', name: '微信提醒' }
]
/* 默认矩阵（来源 → 级别 → 渠道）：紧急全通道（微信除外需绑定），重要减短信，一般只留系统，讨论群一般不打扰；
   未列出的级别默认空（不通知），新级别自动按空起步由用户配置 */
export const NOTIFY_MATRIX_DEFAULTS: Record<string, Record<string, string[]>> = {
  todo:     { urgent: ['inapp', 'push', 'app', 'sms', 'email'], important: ['inapp', 'push', 'app'], normal: ['inapp'] },
  approval: { urgent: ['inapp', 'push', 'app', 'sms', 'email'], important: ['inapp', 'push', 'app', 'email'], normal: ['inapp'] },
  announce: { urgent: ['inapp', 'push', 'app', 'email'], important: ['inapp', 'app'], normal: ['inapp'] },
  group:    { urgent: ['inapp', 'push', 'app'], important: ['inapp', 'app'], normal: [] }
}
